module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has(_vm.validationKey)
    }
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [(_vm.isRequired) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.label))]), _vm._v(" "), _c('select', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validators),
      expression: "validators"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.name,
      "placeholder": _vm.label,
      "name": _vm.name,
      "data-vv-as": _vm.label
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }, 'select', _vm.$attrs, false), _vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n      " + _vm._s(option.label) + "\n    ")])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.validationKey)),
      expression: "errors.has(validationKey)"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.validationKey)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e1a0e4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/FormSelect.vue
// module id = 1692
// module chunks = 1